import React from 'react';

import PdfSectionContainer from './pdf/pdf_container.jsx';
import TextSectionContainer from './text/text_container.jsx';
import IframeEmbedSectionContainer from './iframe_embed/iframe_embed_container.jsx';
import PresentationSectionContainer from './presentation/presentation_container.jsx';
import HtmlPackageSectionContainer from './html_package/html_package_container.jsx';
import SlideshowSectionContainer from './slideshow/slideshow_base_container.jsx';
import VideoPlaylistSectionContainer from './videoplaylist/video_playlist_container.jsx';
import GridSectionContainer from './grid/grid_section_container.jsx';
import JobFeedSectionContainer from './job_feed/job_feed_container.jsx';
import AccordionSectionContainer from './accordion/accordion_container.jsx';
import TabsSectionContainer from './tabs/tabs_container.jsx';
import SectionManagerForViewerContainer from './shared/section_manager_for_viewer_container.jsx';

import {
  SECTION_TYPE_JOB_FEED,
  SECTION_TYPE_ACCORDION,
  SECTION_TYPE_TABS
} from 'zoomforth_codesbane_viewer/const/sections.js';


const SectionsRoot = ({ section, onSectionRefReceive, ...props })=> {
  const isMobile = props.isMobile;

  var SectionRenderer, sectionWrapperClassname;

  switch (section.type) {
    
  case 'pdf': {
    SectionRenderer = PdfSectionContainer;
    sectionWrapperClassname = `section-type-pdf ${isMobile ? 'pdf-mobile-viewer' : ''}`;
    break;
  }

  case 'text': {
    SectionRenderer = TextSectionContainer;
    sectionWrapperClassname = 'section-type-text';
    break;
  }

  case 'iframe_embed': {
    SectionRenderer = IframeEmbedSectionContainer;
    sectionWrapperClassname = 'section-type-iframe-embed';
    break;
  }

  case 'presentation': {
    SectionRenderer = PresentationSectionContainer;
    sectionWrapperClassname = 'section-type-presentation';
    break;
  }

  case 'html_package': {
    SectionRenderer = HtmlPackageSectionContainer;
    sectionWrapperClassname = 'section-type-html-package';
    break;
  }

  case 'slideshow': {
    SectionRenderer = SlideshowSectionContainer;
    sectionWrapperClassname = `section-type-slideshow ${isMobile ? 'slideshow-mobile-viewer' : ''}`;
    break;
  }

  case 'videoplaylist': {
    SectionRenderer = VideoPlaylistSectionContainer;
    sectionWrapperClassname = `section-type-playlist ${isMobile ? 'playlist-mobile-viewer' : ''}`;
    break;
  }

  case 'tiles': {
    SectionRenderer = GridSectionContainer;
    sectionWrapperClassname = `section-type-grid ${isMobile ? 'grid-mobile-viewer' : ''}`;
    break;
  }

  case SECTION_TYPE_JOB_FEED: {
    SectionRenderer = JobFeedSectionContainer;
    sectionWrapperClassname = 'section-type-job-feed';
    break;
  }

  case SECTION_TYPE_ACCORDION: {
    SectionRenderer = AccordionSectionContainer;
    sectionWrapperClassname = 'section-type-accordion';
    break;
  }

  case SECTION_TYPE_TABS: {
    SectionRenderer = TabsSectionContainer;
    sectionWrapperClassname = 'section-type-tabs';
    break;
  }

  default: {
    throw new Error(`Cannot display section. Unexpected section type ${section.type}`);
  }

  }

  return (
    <SectionManagerForViewerContainer
      section={section}
      sectionProps={props}
      SectionRenderer={SectionRenderer}
      sectionWrapperClassname={sectionWrapperClassname}
      onSectionRefReceive={onSectionRefReceive}
    />
  );

};

export default SectionsRoot;
